/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_S5_Written_BeforeInputs */

const tr_hakkimizda_s5_written_before = /** @type {(inputs: Hakkimizda_S5_Written_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yazılı talepler için`)
};

const en_hakkimizda_s5_written_before = /** @type {(inputs: Hakkimizda_S5_Written_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For written requests`)
};

const de_hakkimizda_s5_written_before = /** @type {(inputs: Hakkimizda_S5_Written_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für schriftliche Anfragen`)
};

const ru_hakkimizda_s5_written_before = /** @type {(inputs: Hakkimizda_S5_Written_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для письменных обращений`)
};

/**
* | output |
* | --- |
* | "For written requests" |
*
* @param {Hakkimizda_S5_Written_BeforeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_s5_written_before = /** @type {((inputs?: Hakkimizda_S5_Written_BeforeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_S5_Written_BeforeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_s5_written_before(inputs)
	if (locale === "de") return de_hakkimizda_s5_written_before(inputs)
	if (locale === "ru") return ru_hakkimizda_s5_written_before(inputs)
	return tr_hakkimizda_s5_written_before(inputs)
});